var _defs, _line, _path, _path2, _path3, _rect, _path4, _line2, _line3, _line4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgId(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}.a{stroke:#1c4db8;}.b{fill:#1c4db8;}.c{stroke:#e82e5f;}.d{fill:#e82e5f;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "014-voter-id-proof") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 32.231,
    y1: 36.432,
    x2: 18.563,
    y2: 36.432
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.877,34.226V12.346a1.978,1.978,0,0,1,1.978-1.978H51.788a1.978,1.978,0,0,1,1.978,1.978v12.73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.877,26.628,5.914,29.063A5.51,5.51,0,0,0,2.306,32.67,20.013,20.013,0,0,1,1.5,34.752"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.993,36.506l4.192-3.314a3.667,3.667,0,0,1,5.393.953,2.158,2.158,0,0,1-.507,2.83c-2.473,1.938-5.077,4.446-5.077,4.446s-1.819,7.565-8.928,8.211"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 16.263,
    y: 14.915,
    width: 12.918,
    height: 13.443
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M26.353,23.66l-2.366-1.216a2.688,2.688,0,1,0-2.53,0L19.091,23.66a1.256,1.256,0,0,0-.683,1.117v3.581h8.627V24.777A1.255,1.255,0,0,0,26.353,23.66Z"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 33.805,
    y1: 15.329,
    x2: 39.565,
    y2: 15.329
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 33.805,
    y1: 19.627,
    x2: 42.851,
    y2: 19.627
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 33.805,
    y1: 24.692,
    x2: 42.034,
    y2: 24.692
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M48.5,14.12l.615,1.493,1.244.019a.306.306,0,0,1,.207.537l-1.1.944.576,1.386a.326.326,0,0,1-.47.4l-1.433-.838-1.458.792a.327.327,0,0,1-.458-.416l.62-1.366-1.064-.979a.305.305,0,0,1,.222-.53l1.244.02.664-1.472A.329.329,0,0,1,48.5,14.12Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M55.048,37.831A8.743,8.743,0,1,1,49.5,29.687"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M57.8,30.64a.5.5,0,0,0-.277-.868c-1.416-.166-4.27.141-7.838,3.907a48.741,48.741,0,0,0-3.6,4.341c-.8-.816-3.417-3.226-4.765-1.789a.5.5,0,0,0-.035.642c.69.916,2.791,3.715,3.426,4.694a1.7,1.7,0,0,0,2.888,0,44.426,44.426,0,0,1,4.453-5.523C53.282,34.748,56.405,31.9,57.8,30.64Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgId);
export default __webpack_public_path__ + "static/media/id.be2f2a92.svg";
export { ForwardRef as ReactComponent };